import api from './api';

export type MaintenanceOfferType = 'on_demand' | 'annual';
export type MaintenanceEquipmentCategory = 'all' | 'mural' | 'cassette' | 'allege_armoire' | 'gainable';
export type MaintenancePricingMode = 'per_equipment' | 'flat';

/** Option payante non incluse dans l'abonnement de base */
export interface PaidOption {
  label: string;          // Libellé de l'option
  price: number | null;   // null = sur devis
  note?: string;          // Ex: 'FCFA', 'Sur devis'
  isCustom?: boolean;     // true si ajoutée manuellement par l'admin
}

export interface MaintenanceOffer {
  id: number;
  title: string;
  description: string;
  price: number;
  priceNote?: string;
  price_note?: string;
  offer_type: MaintenanceOfferType;
  equipment_category: MaintenanceEquipmentCategory;
  pricing_mode: MaintenancePricingMode;
  duration?: number;
  duration_months?: number;
  visits_total?: number;
  visit_interval_months?: number;
  annual_discount_percentage?: number;
  includes_freon?: boolean;
  features: string[];
  paidOptions: PaidOption[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateMaintenanceOfferDto {
  title: string;
  description: string;
  price: number;
  priceNote?: string;
  offer_type: MaintenanceOfferType;
  equipment_category: MaintenanceEquipmentCategory;
  pricing_mode: MaintenancePricingMode;
  duration_months?: number;
  visits_total?: number;
  visit_interval_months?: number;
  annual_discount_percentage?: number;
  includes_freon?: boolean;
  features: string[];
  paidOptions?: PaidOption[];
  isActive?: boolean;
}

export const maintenanceOfferService = {
  // Récupérer toutes les offres
  getAll: async (): Promise<MaintenanceOffer[]> => {
    const response = await api.get('/maintenance-offers');
    return response.data.data;
  },

  // Récupérer une offre par ID
  getById: async (id: number): Promise<MaintenanceOffer> => {
    const response = await api.get(`/maintenance-offers/${id}`);
    return response.data.data;
  },

  // Créer une nouvelle offre
  create: async (data: CreateMaintenanceOfferDto): Promise<MaintenanceOffer> => {
    const response = await api.post('/maintenance-offers', data);
    return response.data.data;
  },

  // Mettre à jour une offre
  update: async (id: number, data: Partial<CreateMaintenanceOfferDto>): Promise<MaintenanceOffer> => {
    const response = await api.put(`/maintenance-offers/${id}`, data);
    return response.data.data;
  },

  // Supprimer une offre
  delete: async (id: number): Promise<void> => {
    await api.delete(`/maintenance-offers/${id}`);
  },

  // Activer/Désactiver une offre
  toggleActive: async (id: number, isActive: boolean): Promise<MaintenanceOffer> => {
    const response = await api.patch(`/maintenance-offers/${id}/toggle`, { isActive });
    return response.data.data;
  }
};
